import type { ColumnBehavior } from "../types";

export const getColumnBehavior = (col: unknown): Required<ColumnBehavior> => {
	const behavior = col as ColumnBehavior;
	return {
		enableSort: behavior.enableSort ?? true,
		enableFilter: behavior.enableFilter ?? true,
		sortLabelType: behavior.sortLabelType ?? "default",
	};
};

export const getSortLabels = (sortLabelType: Required<ColumnBehavior>["sortLabelType"]) => {
	switch (sortLabelType) {
		case "text":
			return { ascend: "A to Z", descend: "Z to A" };
		case "number":
			return { ascend: "Low to High", descend: "High to Low" };
		case "date":
			return { ascend: "Oldest to Newest", descend: "Newest to Oldest" };
		case "status":
			return {
				ascend: "Earliest Stage to Latest Stage",
				descend: "Latest Stage to Earliest Stage",
			};
		default:
			return { ascend: "Ascending", descend: "Descending" };
	}
};
